export enum VorgangStatus {
  ZU_PRUEFEN = "zu prüfen",
  GESPERRT = "gesperrt",
  GESPERRT_DURCH_PG = "gesperrt durch PG",
  OK = "ok",
  NICHT_OK = "nicht ok",
  EINGESPIELT = "eingespielt",
  NICHT_EINGESPIELT = "nicht eingespielt"
}
